var _use, _use2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFedora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 267 267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 266.626,133.506 C 266.626,59.981 207.022,0.376 133.498,0.376 C 60.007,0.376 0.426,59.931 0.374,133.412 L 0.374,236.433 C 0.414,253.118 13.945,266.624 30.64,266.624 L 133.552,266.624 C 207.052,266.595 266.626,207.011 266.626,133.506",
    style: {
      fill: "#294172"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.126,142.098 C 77.126,142.098 124.971,142.098 124.971,142.098 C 124.971,142.098 124.971,189.942 124.971,189.942 C 124.971,216.353 103.537,237.787 77.126,237.787 C 50.716,237.787 29.282,216.353 29.282,189.942 C 29.282,163.532 50.716,142.098 77.126,142.098 z",
    id: "in",
    style: {
      fill: "none",
      stroke: "#3c6eb4",
      strokeWidth: 29.21
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1,0,0,-1,249.712,284.288)",
    xlinkHref: "#in"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 139.607,127.529 L 139.607,189.876 C 139.607,224.379 111.632,252.355 77.127,252.355 C 71.892,252.355 68.17,251.764 63.324,250.498 C 56.258,248.649 50.484,242.855 50.482,236.117 C 50.482,227.971 56.394,222.047 65.232,222.047 C 69.438,222.047 70.965,222.854 77.127,222.854 C 95.318,222.854 110.074,208.119 110.106,189.928 L 110.106,161.271 C 110.106,158.703 108.02,156.623 105.448,156.623 L 83.782,156.618 C 75.71,156.618 69.188,150.18 69.188,142.086 C 69.184,133.941 75.777,127.529 83.937,127.529",
    id: "free",
    style: {
      fill: "#ffffff"
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1,0,0,-1,249.712,284.288)",
    xlinkHref: "#free"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedora);
export default __webpack_public_path__ + "static/media/fedora.a4ba3a343313858c9d09fa6874e79994.svg";
export { ForwardRef as ReactComponent };